import styled from "styled-components";
import colours from "assets/colours";
import { fonts } from "assets/fontStyles";

const Form = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const FieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

const Error = styled.div`
  display: flex;
  color: ${colours.primary};
  font-weight: 500;
  font-size: 0.875rem;
  padding: 5px 20px 0px 20px;
  align-self: flex-start;
`;

const Label = styled.label`
  ${fonts.label}
  padding-left: 0.55em;
  white-space: nowrap;
`;

export { Form, FieldWrapper, Error, Label };
